
export class CampoDinamico {
  id: number;
  nombre: string;
  field: string;
  posicion: number;
  codigo: string;
  estado: boolean;
  valido: boolean;
  mensaje: string;
  tablaRelacionada: string;

  constructor() {
    this.id = 0;
    this.nombre = '';
    this.posicion = 0;
    this.codigo = '';
    this.estado = false;
    this.valido = false;
    this.mensaje = '';
    this.tablaRelacionada = '';
  }

  copiar(objeto: any) {
    this.id = objeto.id;
    this.nombre = objeto.nombre;
    this.field = objeto.field;
    this.posicion = objeto.posicion;
    this.codigo = objeto.codigo;
    this.estado = objeto.estado;
    this.valido = objeto.valido;
    this.mensaje = objeto.mensaje;
    this.tablaRelacionada = objeto.tablaRelacionada;
  }
}
